// src/contexts/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';


const AuthContext = createContext();


export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState(''); // Error message state
    const [successMessage, setSuccessMessage] = useState(''); // Success message state

    useEffect(() => {
        const checkUserLoggedIn = async () => {
            console.log("Checking Session");
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/check-session`, {
                    method: 'GET',
                    credentials: 'include',
                });
                if (response.ok) {
                    const data = await response.json();
                    console.log(data);
                    setCurrentUser(data);
                } else {
                    setCurrentUser(null);
                }
            } catch (error) {
                console.error("Failed to check if user is logged in", error);
                setCurrentUser(null);
            } finally {
                setLoading(false);
            }
        };

        checkUserLoggedIn();
    }, []);

    const login = async (email, password) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ email, password }),
            });
            if (response.ok) {
                const data = await response.json();
                setCurrentUser(data.user);
                setSuccessMessage("Login successful!");
                return true;
            } else {
                const errorData = await response.json();
                setErrorMessage(errorData.message || "Login failed.");
                return false;
            }
        } catch (error) {
            console.error("Login failed:", error);
            setErrorMessage("Login failed due to a network error.");
            return false;
        }
    };

    const register = async (username, email, password) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/register`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ username, email, password }),
            });
            if (response.ok) {
                const data = await response.json();
                setCurrentUser(data.user);
                setSuccessMessage("Registration successful!");
                return true;
            } else {
                const errorData = await response.json();
                setErrorMessage(errorData.message || "Registration failed.");
                return false;
            }
        } catch (error) {
            console.error("Registration failed:", error);
            setErrorMessage("Registration failed due to a network error.");
            return false;
        }
    };

    const logout = async () => {

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/logout`, {
                method: 'GET',
                credentials: 'include',
            });
            if (response.ok) {
                console.log("Logout")
                setCurrentUser(null);
                setSuccessMessage("Logout successful!");
            } else {
                setErrorMessage("Logout failed.");
            }
        } catch (error) {
            console.error("Logout failed:", error);
            setErrorMessage("Logout failed due to a network error.");
        }
    };

    return (
        <AuthContext.Provider value={{ currentUser, loading, login, register, logout, errorMessage, successMessage }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
  return useContext(AuthContext);
};